import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@.ui';
import { LinkHelper } from '@/Services';
import { SpClusterDashboardStoreResource } from '@/Types/serviceProviderClusters';

import S from './StoreCard.module.scss';

interface StoreCardProps {
    store: SpClusterDashboardStoreResource;
}

export const StoreCard: FC<StoreCardProps> = ({ store }) => {
    const href = LinkHelper.iRomaScentsNotificationsWithStoreQuery(store.id);

    const location = [store.country, store.region, store.city, store.street_address_1, store.street_address_2].join(', ');

    const getIconStatus = (status: boolean): 'green' | 'red' => {
        return status ? 'red' : 'green';
    };

    const createIconWithStatus = (icon: string, status: boolean): ReactNode => {
        const iconName = `${icon}-${getIconStatus(status)}`;

        return <Icon name={iconName} />;
    };

    return (
        <Link className={S.root} to={href}>
            <div className={S.header}>
                <div className={S.indicators}>
                    {!!store.stations_count && !!store.devices_count && (
                        <>
                            {createIconWithStatus('cluster-store-offline-status', store.has_offline_stations)}
                            {createIconWithStatus('cluster-low-battery-stations-status', store.has_low_battery_stations)}
                            {createIconWithStatus('cluster-low-battery-devices-status', store.has_low_battery_devices)}
                            {createIconWithStatus('cluster-critical-level-chambers-devices', store.has_critical_level_chambers_devices)}
                            {createIconWithStatus('cluster-expired-license-devices', store.has_expired_license_devices)}
                        </>
                    )}
                </div>
                <div className={S.header__stations}>
                    <Icon name="irs-station" size={20} color="black" />
                    {store.stations_count} | {store.devices_count}
                </div>
            </div>

            <div className={S.body}>
                <h6 className={S.body__name}>{store.name}</h6>
            </div>

            <div className={S.footer}>
                <Icon className={S.footer__icon} name="pin" size={24} />
                {location}
            </div>
        </Link>
    );
};
